// $(document).ready(function(){
//     sliderInitfunc();

//     // Initial state
//     $(".hover_img_dup").hide();
//     $(".hover_img_orig").show();

//     $(".grid__item").each(function() {
//         $(this).hover(
//             function() {
//                 // Mouse enter

//                 // Pehle sabko original state mein lao
//                 $(".hover_img_dup").hide();
//                 $(".hover_img_orig").show();

//                 // Current item ka duplicate show
//                 $(this).find(".hover_img_dup").show();

//                 // Current item ka original hide
//                 $(this).find(".hover_img_orig").hide();

//                 // Finally class add
//                 $(this).addClass("is-hovered");
//             },
//             function() {
//                 // Mouse leave
//                 $(this).removeClass("is-hovered");
//             }
//         );
//     });
// });


// $(document).ready(function(){
    

//     // Initial state
//     // $(".hover_img_dup").hide();
//     // $(".hover_img_orig").show();

//     $(".grid__item").each(function() {
//         $(this).hover(
//             function() {
//                 // Mouse enter

//                 // Sab products ko original state mein lao
//                 $(".hover_img_dup").hide();
//                 $(".hover_img_orig").show();

//                 // Current product ka duplicate show
//                 $(this).find(".hover_img_dup").show();

//                 // Current product ka original hide
//                 $(this).find(".hover_img_orig").hide();

//                 // Class add
//                 $(this).addClass("is-hovered");
//             },
//             function() {
//                 // Mouse leave

//                 // Current product ko original state mein lao
//                 $(this).find(".hover_img_dup").hide();
//                 $(this).find(".hover_img_orig").show();

//                 // Class remove
//                 $(this).removeClass("is-hovered");
//             }
//         );
//     });
// });


$(document).ready(function () {

  $(".grid__item").each(function () {

    var $gridItem = $(this);
    var $original = $gridItem.find(".hover_img_orig");
    var $duplicate = $gridItem.find(".hover_img_dup");
    var $variant = $gridItem.find(
      ".jtpl-pro-variant-cstm, .jtpl-pro-variant-cstm-gem"
    );

    // Initial state
    $duplicate.hide();
    $original.show();

    // Grid item hover
    $gridItem.on("mouseenter", function () {

      $duplicate.show();
      $original.hide();

      $gridItem.addClass("is-hovered");

    });

    // Grid item leave
    $gridItem.on("mouseleave", function () {

      $duplicate.hide();
      $original.show();

      $gridItem.removeClass("is-hovered");

    });

    // Variant / Gemstone hover
    $variant.on("mouseenter", function () {

      $duplicate.hide();
      $original.show();

    });

    // Variant / Gemstone leave
    $variant.on("mouseleave", function () {

      if ($gridItem.is(":hover")) {
        $duplicate.show();
        $original.hide();
      }

    });

  });

});